//#region src/app-metrics-route-query.ts
/** The path of the route on core-api, the target of the CP hop over the DP gateway. */
const APP_METRICS_ROUTE_PATH = "/internal/observability/app-metrics";
/** The longest slug or fixture id the route admits: the k8s pod-name ceiling, a ReDoS bound. */
const APP_METRICS_MAX_ID_PART_LENGTH = 253;
/** The longest window the route admits, in milliseconds: 7 days, the longest console app window. */
const MAX_APP_METRICS_WINDOW_MS = 6048e5;
/** The longest `start` or `end` text the schema admits, before the RFC3339 check. */
const APP_METRICS_INSTANT_MAX_LENGTH = 64;
/**
* The charts the route answers: the three Mimir charts of the site-admin-api catalog
* (`APP_METRIC_CHARTS`). The other charts of `appMetricChartSchema` have no Mimir expression.
*/
const APP_METRICS_CHARTS = [
	"cpu",
	"memory",
	"pod-count"
];
/** The Prometheus `step` values of the four console windows (1h, 6h, 24h, 7d). */
const APP_METRICS_STEPS = [
	"60s",
	"300s",
	"900s",
	"3600s"
];
/**
* The RFC3339 instant grammar of `start` and `end`: a date, `T`, a time, at most three fraction
* digits, and `Z` or a `+hh:mm` / `-hh:mm` offset. Prometheus parses this form. Three digits keep
* `Date.parse` exact, so the 7-day check sees the true window. A date alone, a time with no zone
* and an epoch fail. Linear: one pass with fixed quantifiers, and the schema bounds the input at 64
* characters first. A month 13 matches the grammar and `Date.parse` refuses it, so a caller checks
* both.
*/
const RFC3339_INSTANT_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?(Z|[+-]\d{2}:\d{2})$/;
//#endregion
export { APP_METRICS_CHARTS, APP_METRICS_INSTANT_MAX_LENGTH, APP_METRICS_MAX_ID_PART_LENGTH, APP_METRICS_ROUTE_PATH, APP_METRICS_STEPS, MAX_APP_METRICS_WINDOW_MS, RFC3339_INSTANT_PATTERN };

//# sourceMappingURL=app-metrics-route-query.js.map